import { gerarPixPayload } from "./pix";

// PDV (Caixa): mesmo gerador do resto do app (utils/pix.js) — chave no formato
// que o Pix exige, nome/cidade dentro do limite e CRC. Antes o PDV tinha um
// gerador próprio que usava a chave como digitada.
export function gerarPix({ chave, beneficiario, cidade, valor, txId = "***" }) {
  return gerarPixPayload({ chave, nome: beneficiario, cidade, valor, txid: txId });
}
